import React from 'react';
import { NotePencilIcon, RulerIcon, ServicesSimpleIcon, TruckIcon, WrenchIcon } from '@fronton/icons-react';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { stage, stageIcon, stages } from './stages-styles';

export const Stages = () => (
  <Section>
    <SectionSubTitle margin="l">
      Поможем вам с любым этапом работ
    </SectionSubTitle>
    <div className={stages}>
      <div className={stage}>
        <RulerIcon className={stageIcon} type='duotone' size='xxl' color='control-accent'/>
        <Typography size="body_long" variant="m">
          Замер помещения
        </Typography>
      </div>
      <div className={stage}>
        <NotePencilIcon className={stageIcon} type='duotone' size='xxl' color='control-accent'/>
        <Typography size="body_long" variant="m">
          Бесплатный дизайн проект
        </Typography>
      </div>
      <div className={stage}>
        <TruckIcon className={stageIcon} type='duotone' size='xxl' color='control-accent'/>
        <Typography size="body_long" variant="m">
          Доставка и&nbsp;сборка&nbsp;кухни
        </Typography>
      </div>
      <div className={stage}>
        <ServicesSimpleIcon className={stageIcon} type='duotone' size='xxl' color='control-accent'/>
        <Typography size="body_long" variant="m">
          Установка и&nbsp;подключение бытовой техники
        </Typography>
      </div>
      <div className={stage}>
        <WrenchIcon className={stageIcon} type='duotone' size='xxl' color='control-accent'/>
        <Typography size="body_long" variant="m">
          Установка крана, мойки и&nbsp;фильтров
        </Typography>
      </div>
    </div>
  </Section>
);
